export default "/_next/static/images/9350374c2ee0a70e7a96aff54b6d8552.jpg";